import { Card, CardContent, Divider } from "@mui/material";
import { CandidateAccordions } from "../CandidateAccordions/CandidateAccordions";
import ProfilePhotoName from "./Subcomponents/ProfilePhotoName";
import ProfileQuickActions from "./Subcomponents/ProfileQuickActions";

export function ProfileInfo() {
  return (
    <Card sx={{ marginBottom: "20px" }}>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <ProfilePhotoName
          sx={{
            width: "100%",
            display: { xs: "flex", md: "block" },
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "1rem",
          }}
        />
        <ProfileQuickActions sx={{ width: "100%", mt: "1rem" }} />
        <Divider sx={{ color: "text.primary", width: "100%", my: "1rem" }} />
        <CandidateAccordions sx={{ width: "100%" }} />
      </CardContent>
    </Card>
  );
}
